
<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 10.5V12M9 10.5C9 9.67157 8.32843 9 7.5 9H6.375C5.54657 9 4.875 8.32843 4.875 7.5V6M9 10.5C9 9.67157 9.67157 9 10.5 9H11.625C12.4534 9 13.125 8.32843 13.125 7.5V6M6.9375 4.125C6.9375 5.26409 6.01409 6.1875 4.875 6.1875C3.73591 6.1875 2.8125 5.26409 2.8125 4.125C2.8125 2.98591 3.73591 2.0625 4.875 2.0625C6.01409 2.0625 6.9375 2.98591 6.9375 4.125ZM15.1875 4.125C15.1875 5.26409 14.2641 6.1875 13.125 6.1875C11.9859 6.1875 11.0625 5.26409 11.0625 4.125C11.0625 2.98591 11.9859 2.0625 13.125 2.0625C14.2641 2.0625 15.1875 2.98591 15.1875 4.125ZM11.0625 13.875C11.0625 15.0141 10.1391 15.9375 9 15.9375C7.86091 15.9375 6.9375 15.0141 6.9375 13.875C6.9375 12.7359 7.86091 11.8125 9 11.8125C10.1391 11.8125 11.0625 12.7359 11.0625 13.875Z"
      stroke="currentColor"
      stroke-width="1.125"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  name: 'ConnectionIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>
<style scoped>
</style>
